import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PublicReport() {
  const { id } = useParams();
  const [report, setReport] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    axios.get(`${API}/public/reports/${id}`).then((r) => setReport(r.data)).catch(() => setError("Report not found or has been removed."));
  }, [id]);

  if (error) {
    return (
      <div className="grain min-h-screen flex items-center justify-center px-6">
        <div className="text-center">
          <p className="label-eyebrow mb-3">gully</p>
          <p className="text-neutral-400">{error}</p>
          <Link to="/" className="mt-6 inline-block btn-ghost text-sm">Visit Gully</Link>
        </div>
      </div>
    );
  }

  if (!report) {
    return (
      <div className="grain min-h-screen flex items-center justify-center text-neutral-500">Loading…</div>
    );
  }

  return (
    <div className="grain min-h-screen">
      {/* Minimal public top bar */}
      <div className="border-b" style={{ borderColor: "var(--border-default)" }}>
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <span className="font-display text-2xl tracking-tight">gully</span>
            <span className="label-eyebrow ml-1">cricket coach</span>
          </Link>
          <Link to="/login" className="btn-ghost text-xs">Start your own</Link>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 py-12">
        <p className="label-eyebrow mb-3">
          shared today's report · {new Date(report.created_at).toLocaleDateString(undefined, { month: "long", day: "numeric", year: "numeric" })}
          {report.author_name ? ` · ${report.author_name}` : ""}
        </p>
        <h1 className="font-display font-light text-3xl sm:text-4xl tracking-tight mb-2">
          {report.what_happened?.split(".")[0]}.
        </h1>
        <p className="text-neutral-500 mb-12">
          {report.performance_rating ? `Rated ${report.performance_rating}/10. ` : ""}
          {report.confidence_score != null ? `Confidence ${report.confidence_score}/10. ` : ""}
          {report.decision_score != null ? `Decision making ${report.decision_score}/10.` : ""}
        </p>

        {report.sentence_to_remember && (
          <div className="fade-up mb-px py-10 px-8 sm:py-12 sm:px-10" style={{ background: "radial-gradient(ellipse at 25% 30%, rgba(167,243,208,0.07), transparent 55%), var(--bg-surface-1)", border: "1px solid var(--border-default)" }}>
            <p className="label-eyebrow mb-6" style={{ color: "var(--highlight)" }}>one sentence to remember</p>
            <p className="font-display font-light text-2xl sm:text-3xl lg:text-4xl leading-[1.2] tracking-tight text-neutral-100">
              <span className="text-[#A7F3D0] mr-1">“</span>{report.sentence_to_remember}<span className="text-[#A7F3D0] ml-1">”</span>
            </p>
          </div>
        )}

        <div className="bento-card mb-px"><p className="label-eyebrow mb-3">match summary</p><p className="text-neutral-100 leading-relaxed text-lg">{report.what_happened}</p></div>

        {(report.what_you_did_well || report.what_hurt_you) && (
          <div className="grid md:grid-cols-2 gap-px mt-px mb-px" style={{ background: "var(--border-default)" }}>
            {report.what_you_did_well && (
              <div className="surface-1 p-6" style={{ borderTop: "2px solid var(--highlight)" }}>
                <p className="label-eyebrow mb-3" style={{ color: "var(--highlight)" }}>what you did well</p>
                <p className="text-neutral-100 leading-relaxed">{report.what_you_did_well}</p>
              </div>
            )}
            {report.what_hurt_you && (
              <div className="surface-1 p-6" style={{ borderTop: "2px solid var(--warning)" }}>
                <p className="label-eyebrow mb-3" style={{ color: "var(--warning)" }}>what hurt you</p>
                <p className="text-neutral-100 leading-relaxed">{report.what_hurt_you}</p>
              </div>
            )}
          </div>
        )}

        {report.pattern_detected && (
          <div className="bento-card mt-px mb-6" style={{ borderColor: "var(--warning)", background: "rgba(217,119,6,0.04)" }}>
            <p className="label-eyebrow mb-3" style={{ color: "var(--warning)" }}>pattern detected</p>
            <p className="font-display text-xl text-neutral-100 leading-snug">{report.pattern_detected}</p>
          </div>
        )}

        <div className="bento-card mb-16" style={{ borderColor: "var(--highlight)" }}>
          <p className="label-eyebrow mb-3" style={{ color: "var(--highlight)" }}>next match challenge</p>
          <p className="font-display text-2xl sm:text-3xl text-[#A7F3D0] font-light leading-snug">
            {report.next_match_challenge}
          </p>
        </div>

        <div className="border-t pt-10" style={{ borderColor: "var(--border-default)" }}>
          <p className="label-eyebrow mb-3">about gully</p>
          <p className="text-neutral-400 leading-relaxed mb-5 max-w-xl">
            Gully is a cricket companion. It helps players understand what happened, why it happened, and what to work on next.
          </p>
          <Link to="/login" className="btn-primary text-sm">Start your own Cricket Review →</Link>
        </div>
      </div>
    </div>
  );
}
